// Define the effective connection types that are suitable for performing image
// preloading. In theory, 2G connections are "suited for transfers of small images"
// but we won't preload on 2G. 3G connections are "suited for transfers of large assets"
// so we'll assume that they can handle a bunch of ~2KB images while fetching.
// The Network Information API is still in draft form, so these types are subject to change:
// http://wicg.github.io/netinfo/#dfn-effective-connection-type
const PRELOADABLE_CONNECTION_TYPES = [
  '3g',
  '4g',
];

/**
 * Preload images from an array of URLs.
 * @param {*} urls
 */
export default function preloadImages(urls) {
  // Check whether we have access to the Network Information API at all
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (!connection) {
    return;
  }

  // Check whether we have access to a meaningful effective connection type
  // that we judge to be OK for image preloading
  const { effectiveType } = connection;
  console.info(`connection.effectiveType: ${effectiveType}`);
  if (!PRELOADABLE_CONNECTION_TYPES.includes(effectiveType)) {
    return;
  }

  // Go fetch as quickly as possible
  urls.forEach((url) => {
    (new Image()).src = url;
  });
}